"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CodeBench = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
// UI Imports
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
// Components imports
var spinner_svg_1 = __importDefault(require("../../assets/spinner/spinner.svg"));
var code_bench_vw_modal_1 = __importDefault(require("./code-bench.vw-modal"));
var billing_group_1 = require("../billing-group/billing-group");
var code_bench_panel_1 = require("../code-bench-panel/code-bench-panel");
var case_detail_1 = require("../case-detail/case-detail");
var code_bench_action_bar_1 = require("../code-bench-action-bar/code-bench-action-bar");
var process_status_1 = require("../process-status/process-status");
var charge_counts_1 = require("../code-bench-panel/charge-counts/charge-counts");
var timeline_1 = require("../timeline/timeline");
var confirm_1 = require("../confirm/confirm");
var charge_selector_1 = require("../charge-selector/charge-selector");
var improvements_1 = require("../improvements/improvements");
var related_cases_1 = require("../related-cases/related-cases");
var case_status_1 = require("../case-status/case-status");
var standalone_pageable_list_1 = require("../standalone-pageable-list/standalone-pageable-list");
var conditional_1 = require("../conditional/conditional");
var verdigris_1 = require("@codametrix/verdigris");
var TitleTabsEnum;
(function (TitleTabsEnum) {
    TitleTabsEnum["CHANGES_TEXT"] = "See changes to this case";
})(TitleTabsEnum || (TitleTabsEnum = {}));
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
var CodeBench = /** @class */ (function (_super) {
    __extends(CodeBench, _super);
    function CodeBench(props) {
        var _this = _super.call(this, props) || this;
        _this.onCodeUpdate = _this.onCodeUpdate.bind(_this);
        _this.onCodeRemove = _this.onCodeRemove.bind(_this);
        _this.onTimeBasedCodeAdd = _this.onTimeBasedCodeAdd.bind(_this);
        _this.onTimeBasedCodeUpdate = _this.onTimeBasedCodeUpdate.bind(_this);
        _this.onCodeSearchDrop = _this.onCodeSearchDrop.bind(_this);
        _this.onCodeSearch = _this.onCodeSearch.bind(_this);
        _this.onCodeSearchSelection = _this.onCodeSearchSelection.bind(_this);
        _this.onFeatureSelection = _this.onFeatureSelection.bind(_this);
        _this.handleGroupedCaseClick = _this.handleGroupedCaseClick.bind(_this);
        _this.handleModalClose = _this.handleModalClose.bind(_this);
        _this.handleInvoiceEdit = _this.handleInvoiceEdit.bind(_this);
        _this.handlePromptDismiss = _this.handlePromptDismiss.bind(_this);
        _this.handleMetaAction = _this.handleMetaAction.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onModalAddChargeOpen = _this.onModalAddChargeOpen.bind(_this);
        _this.onModalAddChargeClose = _this.onModalAddChargeClose.bind(_this);
        _this.handleAddCharge = _this.handleAddCharge.bind(_this);
        _this.handleTimer = _this.handleTimer.bind(_this);
        _this.handleInvoiceAddition = _this.handleInvoiceAddition.bind(_this);
        _this.handleTransactionSharedDiagnosisChange = _this.handleTransactionSharedDiagnosisChange.bind(_this);
        _this.handleDeleteSizeExpWarning = _this.handleDeleteSizeExpWarning.bind(_this);
        _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
        _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
        _this.caseDetailRef = react_1["default"].createRef();
        _this.iframeRef = react_1["default"].createRef();
        var codeUpdateDebounced = _this.onCodeUpdate.bind(_this);
        _this.onCodeUpdate = ui_common_1.objectUtils.debounce(codeUpdateDebounced, 500);
        _this.handleHARCaseList = _this.handleHARCaseList.bind(_this);
        _this.onMiniTabSelection = _this.onMiniTabSelection.bind(_this);
        return _this;
    }
    CodeBench.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (!this.props.loadAlwaysFromURL)
            return;
        if (((_a = prevProps.match) === null || _a === void 0 ? void 0 : _a.url) !== ((_b = this.props.match) === null || _b === void 0 ? void 0 : _b.url)) {
            this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_g = (_f = (_e = (_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.capabilities) === null || _d === void 0 ? void 0 : _d.capabilities) === null || _e === void 0 ? void 0 : _e.getCaseRunWithRefresh) === null || _f === void 0 ? void 0 : _f.on) !== null && _g !== void 0 ? _g : false);
            this.props.onLoadFromURLMatch(this.props.match);
            var case_uid = (_j = (_h = this.props.match) === null || _h === void 0 ? void 0 : _h.params) === null || _j === void 0 ? void 0 : _j.caseId;
            var caserun_uid = (_l = (_k = this.props.match) === null || _k === void 0 ? void 0 : _k.params) === null || _l === void 0 ? void 0 : _l.id;
            this.props.loadWorkItemDetails(case_uid, caserun_uid);
        }
    };
    CodeBench.prototype.componentDidMount = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.props.loadRoles(this.props.roles);
        var hasActiveItem = !ui_common_1.objectUtils.isEmpty(this.props.activeItem);
        var case_uid = '', caserun_uid = '';
        if (this.props.loadAlwaysFromURL || !hasActiveItem) {
            this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_e = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.capabilities) === null || _b === void 0 ? void 0 : _b.capabilities) === null || _c === void 0 ? void 0 : _c.getCaseRunWithRefresh) === null || _d === void 0 ? void 0 : _d.on) !== null && _e !== void 0 ? _e : false);
            this.props.onLoadFromURLMatch(this.props.match);
            case_uid = (_g = (_f = this.props.match) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.caseId;
            caserun_uid = (_j = (_h = this.props.match) === null || _h === void 0 ? void 0 : _h.params) === null || _j === void 0 ? void 0 : _j.id;
        }
        else {
            this.props.onLoad(this.props.activeItem);
            case_uid = this.props.activeItem.case_uid;
            caserun_uid = this.props.activeItem.caserun_uid;
        }
        this.props.loadWorkItemDetails(case_uid, caserun_uid);
        // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
        this.props.loadServicedeskContext(this.props.cursorAPIContext);
    };
    CodeBench.prototype.handleCancel = function (event) {
        event.preventDefault();
        this.props.onInvoicesCancel(this.props.processInstance);
    };
    CodeBench.prototype.handleSubmit = function (event, vwComment, submitWithOverrideButton, remove_hold) {
        if (vwComment === void 0) { vwComment = null; }
        if (submitWithOverrideButton === void 0) { submitWithOverrideButton = false; }
        if (remove_hold === void 0) { remove_hold = null; }
        event.preventDefault();
        var cursorAPIPayload = {
            operation: ui_common_1.commonEnums.CursorOperation.NEXT,
            cursorAPIContext: this.props.cursorAPIContext
        };
        this.props.onInvoicesSubmisson({
            processInstance: this.props.processInstance,
            uiMode: this.props.UIMode,
            vwComment: vwComment,
            submitWithOverrideButton: submitWithOverrideButton,
            cursorAPIPayload: cursorAPIPayload,
            activeItem: this.props.activeItem,
            removeHold: remove_hold
        });
    };
    CodeBench.prototype.handlePreviousClick = function (event) {
        event.preventDefault();
        var _a = this.props, processInstanceGuids = _a.processInstanceGuids, activeItem = _a.activeItem;
        var loc = processInstanceGuids.findIndex(function (item) { return item === activeItem.process_instance_guid; });
        this.props.handleTraversal(processInstanceGuids[loc - 1]);
    };
    CodeBench.prototype.handleModalClose = function (ev) {
        ev.preventDefault();
        this.props.onPopUpClose();
    };
    CodeBench.prototype.handlePromptDismiss = function (ev) {
        ev.preventDefault();
        this.props.onPrompt('REFRESH_TOKEN');
    };
    CodeBench.prototype.handleConfirm = function (actionItem) {
        this.props.onPopUpClose();
    };
    CodeBench.prototype.handleConfirmDismiss = function (actionItem) {
        this.props.onPopUpClose();
    };
    CodeBench.prototype.handleInvoiceEdit = function (invoice) {
        this.props.onInvoiceEdit(invoice, this.props.processInstance);
    };
    CodeBench.prototype.handleInvoiceAddition = function (invoices) {
        this.props.onInvoiceAddition((invoices && invoices.length > 0
            ? invoices[0]
            : null), this.props.processInstance);
    };
    CodeBench.prototype.handleMetaAction = function (transactionAction) {
        var invoice = this.props.codableInvoices.find(function (invoice) { return invoice.guid === transactionAction.meta.invoice.guid; });
        this.props.onChargeSessionAction(__assign(__assign({}, transactionAction), { meta: __assign(__assign({}, transactionAction.meta), { invoice: invoice, processInstance: this.props.processInstance }) }));
    };
    CodeBench.prototype.handleGroupedCaseClick = function (ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item)
            return;
        var caseId = item.value;
        if (!caseId)
            return;
        var hostCaseId = this.props.hostCaseId
            ? this.props.hostCaseId
            : this.props.activeItem.case_id;
        var replace = hostCaseId !== this.props.activeItem.case_id;
        this.props.onPopUpNavigate({
            caseId: item.value,
            replace: replace,
            serviceLine: this.props.activeItem.service_line,
            hostCaseId: hostCaseId
        });
    };
    CodeBench.prototype.onFeatureSelection = function (selection) {
        this.props.onFeatureActivation(selection);
        this.caseDetailRef.current.onFeatureActivation(selection);
    };
    // The CodeQuery, SearchResult, and CodeChange all rely on a common
    // property called context.  This is what will allow business
    // logic upstream to have standard patterns for figuring out what to do
    // with various actions.
    CodeBench.prototype.onCodeSearch = function (commonCodeQuery) {
        var context = __assign(__assign({}, commonCodeQuery.context), { activeItem: __assign({}, this.props.activeItem), userContext: __assign({}, this.props.userContext) });
        var codeQuery = __assign(__assign({}, commonCodeQuery), { context: context });
        var isMod = codeQuery.searchType === ui_common_1.commonEnums.CodeType.MODIFIER;
        if (isMod) {
            codeQuery.text = "".concat(codeQuery.text).toUpperCase();
        }
        //
        if (codeQuery.text.length > 2 || (codeQuery.text.length === 2 && isMod)) {
            this.props.onCodeSearch(codeQuery);
        }
        else {
            this.props.onSearchClear(codeQuery, commonCodeQuery.searchResultsLookupKey);
        }
    };
    CodeBench.prototype.onCodeSearchSelection = function (commonSearchResult) {
        var _a, _b;
        var defaultPrevented = (_b = (_a = commonSearchResult.context) === null || _a === void 0 ? void 0 : _a.defaultPrevented) !== null && _b !== void 0 ? _b : false;
        if (defaultPrevented) {
            this.props.onSearchClear(commonSearchResult);
        }
        else {
            var context = __assign(__assign({}, commonSearchResult.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
            var searchResult = __assign(__assign({}, commonSearchResult), { context: context });
            this.props.onCodeSearchSelection(searchResult);
        }
    };
    CodeBench.prototype.onCodeUpdate = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeUpdate(changeDetail);
    };
    CodeBench.prototype.onCodeRemove = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeRemove(changeDetail);
    };
    CodeBench.prototype.onTimeBasedCodeAdd = function (commonChangeDetail, time, age) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var codeChange = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onTimeBasedCodeAdd(codeChange, time, age);
    };
    CodeBench.prototype.onTimeBasedCodeUpdate = function (commonChangeDetail, time, age) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var codeChange = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onTimeBasedCodeUpdate(codeChange, time, age);
    };
    CodeBench.prototype.onCodeSearchDrop = function (commonChangeDetail) {
        var context = __assign(__assign({}, commonChangeDetail.context), { activeItem: __assign({}, this.props.activeItem), invoices: __spreadArray([], __read(this.props.codableInvoices), false) });
        var changeDetail = __assign(__assign({}, commonChangeDetail), { context: context });
        this.props.onCodeSearchDrop(changeDetail);
    };
    CodeBench.prototype.handleTransactionSharedDiagnosisChange = function (changeDetail) {
        this.props.onTransactionSharedDiagnosisChange(changeDetail);
    };
    CodeBench.prototype.handleHARCaseList = function (options) {
        var _a, _b, _c;
        this.props.getCasesWithEncounter({
            encounterId: (_b = (_a = this.props.activeItem) === null || _a === void 0 ? void 0 : _a.encounter_identifier) === null || _b === void 0 ? void 0 : _b.number,
            sortablePageable: options,
            serviceLine: (_c = this.props.activeItem) === null || _c === void 0 ? void 0 : _c.service_line,
            noteTypes: this.props.noteTypes
        });
    };
    /**
     * Event that happen when click add charge button
     * @returns {void}
     */
    CodeBench.prototype.onModalAddChargeOpen = function () {
        this.props.onModalAddChargeOpen();
    };
    /**
     * Event that happen when moda of add charge button is closed
     * @returns {void}
     */
    CodeBench.prototype.onModalAddChargeClose = function (e) {
        this.props.onModalAddChargeClose(e);
    };
    /**
     * Event launched when invoice is clicked
     */
    CodeBench.prototype.handleAddCharge = function (invoice) {
        if (invoice.deleted) {
            this.handleInvoiceAddition([invoice]);
        }
        else {
            this.props.handleAddCharge({
                invoiceGuid: invoice.guid,
                processInstanceId: this.props.processInstance.guid.uuid,
                activeItem: this.props.activeItem
            });
        }
    };
    /**
     * Method that is called for decrement timer
     */
    CodeBench.prototype.handleTimer = function () {
        this.props.handleTimer();
    };
    /**
     * Method that is called when user wants to close the modal for size experience warning
     */
    CodeBench.prototype.handleDeleteSizeExpWarning = function () {
        this.props.deleteSizeExpWarning();
    };
    /**
     * Method used for enable a procedure with tech/pro charge
     * @param context
     */
    CodeBench.prototype.handleEnableTechPro = function (techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleEnableTechPro(techCodableTransaction);
    };
    /**
     * Method used for disable a procedure with tech/pro charge
     * @param context
     */
    CodeBench.prototype.handleDisableTechPro = function (techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleDisableTechPro(techCodableTransaction);
    };
    CodeBench.prototype.onMiniTabSelection = function (selection) {
        this.props.setActiveMiniTab(selection.displayName);
    };
    CodeBench.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, nonCodeBench = _c.nonCodeBench, chargeSessions = _c.chargeSessions, counts = _c.counts, searchResults = _c.searchResults, benchEditable = _c.benchEditable, processInstance = _c.processInstance, activations = _c.activations, groupedCases = _c.groupedCases, modalURL = _c.modalURL, hostCaseId = _c.hostCaseId, onChargeSessionAction = _c.onChargeSessionAction, activity = _c.activity, prompt = _c.prompt, confirm = _c.confirm, showSubmittedFeedback = _c.showSubmittedFeedback, showLoadingSubmission = _c.showLoadingSubmission, showLoadingCancelation = _c.showLoadingCancelation, showSizeExpWarning = _c.showSizeExpWarning, showCanceledFeedback = _c.showCanceledFeedback, submittedFeedbackTimer = _c.submittedFeedbackTimer, showvitalwareIssuesModal = _c.showvitalwareIssuesModal, toggleHoldCaseModal = _c.toggleHoldCaseModal, toggleExclusionCaseModal = _c.toggleExclusionCaseModal, toggleSplitCaseModal = _c.toggleSplitCaseModal, vitalwareIssues = _c.vitalwareIssues, mergeSplitHistoryIssues = _c.mergeSplitHistoryIssues, documentImprovementIssues = _c.documentImprovementIssues, holdIssues = _c.holdIssues, hidevitalwareIssuesModal = _c.hidevitalwareIssuesModal, displayAddCharge = _c.displayAddCharge, showAddChargeError = _c.showAddChargeError, showAddChargeLoading = _c.showAddChargeLoading, loadState = _c.loadState, codableInvoices = _c.codableInvoices, feedback = _c.feedback, showFeedBack = _c.showFeedBack, UIMode = _c.UIMode, epicToken = _c.epicToken, codeEdits = _c.codeEdits, invoiceOptions = _c.invoiceOptions, caseEdits = _c.caseEdits, showHoldCaseModal = _c.showHoldCaseModal, hideHoldCaseModal = _c.hideHoldCaseModal, showExclusionCaseModal = _c.showExclusionCaseModal, hideExclusionCaseModal = _c.hideExclusionCaseModal, toggleChargeableCase = _c.toggleChargeableCase, holdCase = _c.holdCase, improvements = _c.improvements, capabilities = _c.capabilities, updateValue = _c.updateValue, updateCase = _c.updateCase, relatedCases = _c.relatedCases, relatedCasesPageable = _c.relatedCasesPageable, flagList = _c.flagList, htmlNotes = _c.htmlNotes, customClaimsRelatedCases = _c.customClaimsRelatedCases, customClaimsRelatedCasesLoadState = _c.customClaimsRelatedCasesLoadState, workItem = _c.workItem, caseDetailProps = __rest(_c, ["nonCodeBench", "chargeSessions", "counts", "searchResults", "benchEditable", "processInstance", "activations", "groupedCases", "modalURL", "hostCaseId", "onChargeSessionAction", "activity", "prompt", "confirm", "showSubmittedFeedback", "showLoadingSubmission", "showLoadingCancelation", "showSizeExpWarning", "showCanceledFeedback", "submittedFeedbackTimer", "showvitalwareIssuesModal", "toggleHoldCaseModal", "toggleExclusionCaseModal", "toggleSplitCaseModal", "vitalwareIssues", "mergeSplitHistoryIssues", "documentImprovementIssues", "holdIssues", "hidevitalwareIssuesModal", "displayAddCharge", "showAddChargeError", "showAddChargeLoading", "loadState", "codableInvoices", "feedback", "showFeedBack", "UIMode", "epicToken", "codeEdits", "invoiceOptions", "caseEdits", "showHoldCaseModal", "hideHoldCaseModal", "showExclusionCaseModal", "hideExclusionCaseModal", "toggleChargeableCase", "holdCase", "improvements", "capabilities", "updateValue", "updateCase", "relatedCases", "relatedCasesPageable", "flagList", "htmlNotes", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "workItem"]);
        var flagListSet = Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) { return flag === null || flag === void 0 ? void 0 : flag.flag; })));
        var actionBar = (0, jsx_runtime_1.jsx)(code_bench_action_bar_1.CodeBenchActionBar, __assign({}, this.props));
        var codeEditingPanel;
        var button, relatedCasesView;
        var isActive = !ui_common_1.caseUtils.isFinishedCase(caseDetailProps.activeItem);
        if (showSubmittedFeedback || showCanceledFeedback) {
            if (submittedFeedbackTimer) {
                window.parent.postMessage({
                    action: 'Epic.Clinical.Informatics.Web.CloseActivity',
                    token: epicToken
                }, '*');
            }
            else {
                this.handleTimer();
            }
        }
        var showProcessStatus = !benchEditable.editable;
        var showModal = modalURL !== null && modalURL.path;
        var modalURI = showModal ? modalURL.path + modalURL.queryString : '';
        var benchLoading = loadState.loading;
        var invoices = (_a = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : invoiceOptions.invoices) !== null && _a !== void 0 ? _a : [];
        var styles = (0, classnames_1["default"])([
            'code-bench',
            {
                'bench-pre-editable': benchEditable.waiting,
                'bench-cancelled': benchEditable.cancelled,
                'bench-loading': benchLoading
            }
        ]);
        if (benchEditable.waiting) {
            codeEditingPanel = (0, jsx_runtime_1.jsx)(process_status_1.ProcessStatus, { benchEditable: benchEditable });
        }
        else {
            var noCodableInvoices = codableInvoices === null || codableInvoices.length === 0;
            var innerBench = (noCodableInvoices && codableInvoices === null) || loadState.loading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 3 }, "loading-slugs")) : ([
                noCodableInvoices ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "no-charges empty-message" }, { children: "No charges found." })) })) : ((0, jsx_runtime_1.jsx)(code_bench_panel_1.CodeBenchPanel, { panelActivations: activations.panel, onChargeSessionAction: this.handleMetaAction, onFeatureSelection: this.onFeatureSelection, editable: benchEditable.editable, benchEditable: benchEditable, caseDetailProps: caseDetailProps, searchResults: searchResults, benchLoading: benchLoading, codeEdits: codeEdits, onInvoiceMetaEdit: this.handleInvoiceEdit, onCodeSearchSelection: this.onCodeSearchSelection, onCodeSearch: this.onCodeSearch, onCodeUpdate: this.onCodeUpdate, onCodeRemove: this.onCodeRemove, onTimeBasedCodeAdd: this.onTimeBasedCodeAdd, onTimeBasedCodeUpdate: this.onTimeBasedCodeUpdate, onCodeSearchDrop: this.onCodeSearchDrop, onTransactionSharedDiagnosisChange: this.handleTransactionSharedDiagnosisChange, counts: counts, processInstance: processInstance, codableInvoices: codableInvoices, showProcessStatus: showProcessStatus, handleEnableTechPro: this.handleEnableTechPro, handleDisableTechPro: this.handleDisableTechPro, customClaimsRelatedCases: this.props.customClaimsRelatedCases, customClaimsRelatedCasesLoadState: this.props.customClaimsRelatedCasesLoadState, openChildWindow: this.props.openChildWindow }, "code-bench-panel")),
                (0, jsx_runtime_1.jsx)("div", { children: benchEditable.editable && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "add-charge-div", onClick: this.onModalAddChargeOpen }, { children: [(0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Plus, titleText: "Add Charge", iconSize: "16", iconClass: "plus-icon" }), (0, jsx_runtime_1.jsx)("a", __assign({ className: "add-charge-btn" }, { children: "Add Charge" }))] }), "add-charge-button")) }),
                (0, jsx_runtime_1.jsxs)("div", __assign({ className: "summary-section" }, { children: [(0, jsx_runtime_1.jsx)("h5", { children: "Summary" }), (0, jsx_runtime_1.jsx)(charge_counts_1.ChargeCounts, { counts: counts })] }), "charge-totals")
            ]);
            var improvementsCapability = conditionalUtils.capabilityValue(capabilities.capabilities.improvements.on);
            if (ui_common_1.AmplifyCore.isIPCServiceline(this.props.activeItem.service_line)) {
                relatedCasesView = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", __assign({ className: "patient-info-link", href: '#/patient-info', onClick: function (ev) {
                                ev.preventDefault();
                                _this.props.showPatientInfo(_this.props.activeItem);
                            } }, { children: "View more patient info" })), (0, jsx_runtime_1.jsx)(standalone_pageable_list_1.StandalonePageableList, __assign({ list: this.handleHARCaseList, sortablePageable: relatedCasesPageable, theme: 'cmx-theme' }, { children: (0, jsx_runtime_1.jsx)(related_cases_1.RelatedCases, { relatedCases: relatedCases, showLoading: benchLoading || caseDetailProps.relatedCasesLoadState.loading, activeItem: this.props.activeItem, onOpenRelatedCase: this.props.openChildWindow, showProviderInfo: this.props.showProviderInfo }) }))] }));
            }
            else {
                relatedCasesView = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: benchLoading || caseDetailProps.billingGroupLoadState.loading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 1 }, "loading-slugs")) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "status-section", onClick: this.handleGroupedCaseClick }, { children: (0, jsx_runtime_1.jsx)(billing_group_1.BillingGroup, { suppressedLinks: [hostCaseId], showProcessStatus: true, isActive: isActive, cancelled: benchEditable.cancelled, groupedCases: groupedCases, showLoading: caseDetailProps.billingGroupLoadState.loading, viewOnly: !benchEditable.editable }) }))) }));
            }
            var miniTabsItems = [
                {
                    id: 'charges',
                    displayName: ui_common_1.commonEnums.MiniTabLabels.CHARGES_LABEL,
                    active: this.props.activeMiniTab ===
                        ui_common_1.commonEnums.MiniTabLabels.CHARGES_LABEL,
                    body: innerBench,
                    icon: ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Coding, iconSize: "18", iconClass: "tab-icon", titleText: ui_common_1.commonEnums.MiniTabLabels.CHARGES_DESCRIPTION })),
                    titleText: ui_common_1.commonEnums.MiniTabLabels.CHARGES_DESCRIPTION
                },
                {
                    id: 'relatedCases',
                    displayName: ui_common_1.commonEnums.MiniTabLabels.RELATED_LABEL,
                    active: this.props.activeMiniTab ===
                        ui_common_1.commonEnums.MiniTabLabels.RELATED_LABEL,
                    body: relatedCasesView,
                    icon: ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Related, iconSize: "18", iconClass: "tab-icon", titleText: ui_common_1.commonEnums.MiniTabLabels.RELATED_DESCRIPTION })),
                    titleText: ui_common_1.commonEnums.MiniTabLabels.RELATED_DESCRIPTION
                },
                {
                    id: 'activity',
                    displayName: ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
                    active: this.props.activeMiniTab ===
                        ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
                    body: (0, jsx_runtime_1.jsx)(timeline_1.Timeline, { items: activity }),
                    icon: ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.History, iconSize: "18", iconClass: "tab-icon", titleText: ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION })),
                    titleText: ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION
                },
                improvementsCapability && {
                    id: 'improvements',
                    displayName: ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
                    active: this.props.activeMiniTab ===
                        ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
                    body: ((0, jsx_runtime_1.jsx)(improvements_1.Improvements, __assign({}, this.props, { improvementsAction: capabilities.capabilities.improvementsAction, showUnresolved: this.props.showUnresolvedDocuments }))),
                    icon: ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Reports, iconSize: "18", iconClass: "tab-icon", titleText: ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION })),
                    titleText: ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION
                }
            ].filter(Boolean);
            codeEditingPanel = [
                (0, jsx_runtime_1.jsxs)(ui_components_1.Card, __assign({ className: "cmx-card-panel" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "status-area" }, { children: benchLoading ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 1 }, "loading-slugs")) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "status-section case-status-section" }, { children: [(0, jsx_runtime_1.jsx)(case_status_1.StatusDescription, { secondaryPrefix: "Review Required", includeBox: true, caseRun: caseDetailProps.activeItem }), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [(flagListSet === null || flagListSet === void 0 ? void 0 : flagListSet.length) > 0] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-section ".concat(ui_common_1.caseUtils.getStatusReason(caseDetailProps.activeItem)
                                                ? 'zeroTopPadding'
                                                : '') }, { children: flagListSet.map(function (flag, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flag-item-box" }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "flag-item", title: flag }, { children: flag })) }), "flag-".concat(index))); }) })) }))] }))) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-sessions" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.MiniTabs, { items: miniTabsItems, onSelection: this.onMiniTabSelection }) }))] }), "charge-sessions"),
                (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: UIMode === ui_common_1.commonEnums.UIModesEnum.EPIC_EMBEDDED ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "debug-box" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ className: "debug-link", href: "/debug" }, { children: "Debug" })) }))) : ('') })
            ];
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles }, { children: [prompt && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "top-level-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: prompt.text, closable: false, onSubmit: this.handlePromptDismiss, buttonText: "Yes", maximize: false }, { children: (0, jsx_runtime_1.jsxs)("p", { children: ["Click ", (0, jsx_runtime_1.jsx)("b", { children: "Yes" }), " below to stay logged in."] }) })) }))), (0, jsx_runtime_1.jsx)(confirm_1.Confirm, __assign({ onConfirm: this.props.handleConfirm, onDismiss: this.props.handleConfirmDismiss }, confirm)), showModal && ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ onClose: this.handleModalClose, maximize: true }, { children: (0, jsx_runtime_1.jsx)("iframe", { ref: this.iframeRef, src: modalURI, className: "popup-frame" }) }))), (showSubmittedFeedback || showCanceledFeedback) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-submitted-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: {
                            message: "Successfully ".concat(showSubmittedFeedback ? 'submitted' : 'canceled'),
                            id: new Date().getTime(),
                            dismissable: true
                        }, showingTime: 3000, dismissFeedback: this.props.hideSubmittedFeedback, showFeedback: showSubmittedFeedback || showCanceledFeedback }) }))), (showLoadingSubmission || showLoadingCancelation) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-submitted-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: {
                            message: "".concat(showLoadingSubmission ? 'Submitting...' : 'Canceling...'),
                            id: new Date().getTime(),
                            dismissable: false,
                            meta: { level: ui_common_1.commonEnums.FeedbackMeta.WARNING }
                        }, showFeedback: showLoadingSubmission || showLoadingCancelation }) }))), displayAddCharge && ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ onClose: this.onModalAddChargeClose, title: showAddChargeLoading ? 'Adding charge' : 'Add a charge for:' }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "qa-add-charge-modal" }, { children: [!showAddChargeLoading ? ((0, jsx_runtime_1.jsx)(charge_selector_1.ChargeSelector, { handleAddCharge: this.handleAddCharge, handleInvoiceAddition: this.handleInvoiceAddition, invoiceOptions: invoiceOptions })) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "spinner-box" }, { children: (0, jsx_runtime_1.jsx)("img", { src: spinner_svg_1["default"], alt: "in progress", className: "spinner" }) }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-error-box" }, { children: showAddChargeError ? ((0, jsx_runtime_1.jsx)("small", __assign({ className: "charge-error-text" }, { children: "Error adding a new charge" }))) : ('') }))] })) }))), (0, jsx_runtime_1.jsx)(case_detail_1.CaseDetail, __assign({ ref: this.caseDetailRef, mode: "code-edit", codeEdits: codeEdits, codeEditingPanel: codeEditingPanel, groupedCases: groupedCases }, caseDetailProps, { loadState: loadState, activations: activations, actionBar: actionBar, updateValue: updateValue, updateCase: updateCase, showAttachDocsModal: this.props.showAttachDocsModal, capability: capabilities.capabilities.caseEdit, coderNotesCapability: capabilities.capabilities.coderNotes, capabilities: capabilities, processInstance: this.props.processInstance, caseEdits: caseEdits, noteUnavailableReason: capabilities.capabilities.noteUnavailableReason, UIMode: this.props.UIMode, showCoderNotesInfo: this.props.showCoderNotesInfo, workItem: workItem })), (0, jsx_runtime_1.jsx)(ui_components_1.UniversalFeedback, { feedback: feedback, dismissFeedback: this.props.hideFeedback, showFeedback: showFeedBack, showingTime: 5000 }), showSizeExpWarning && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "top-level-modal" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: 'Help us improve your experience', closable: true, onClose: this.handleDeleteSizeExpWarning, onSubmit: this.handleDeleteSizeExpWarning, buttonText: "Dismiss", maximize: false }, { children: (0, jsx_runtime_1.jsx)("p", { children: "Consider adjusting the width of your browser to a wider setting for a better view of CMX Amplify." }) })) }))), showvitalwareIssuesModal && ((0, jsx_runtime_1.jsx)(code_bench_vw_modal_1["default"], { onClose: this.props.hidevitalwareIssuesModal, onSubmit: function (event, comment, remove_hold) {
                        return _this.handleSubmit(event, comment, true, remove_hold);
                    }, vitalwareIssues: vitalwareIssues, mergeSplitHistoryIssues: mergeSplitHistoryIssues, documentImprovementIssues: documentImprovementIssues, holdIssues: holdIssues, holdCaseStatus: capabilities.holdCaseStatus, improvements: (_b = this.props.improvements) === null || _b === void 0 ? void 0 : _b.improvements, setActiveMiniTab: this.props.setActiveMiniTab, setUnresolvedDocuments: this.props.setUnresolvedDocuments }))] })));
    };
    CodeBench.defaultProps = {
        benchEditable: __assign({}, ui_common_1.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
        improvements: __assign({}, ui_common_1.AmplifyCore.state.improvements),
        capabilities: __assign({}, ui_common_1.AmplifyCore.state.capabilities),
        relatedCasesLoadState: __assign({}, ui_common_1.loadStates.LOAD_STATES.done),
        relatedCasesPageable: __assign({}, ui_common_1.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
        processInstanceGuids: [],
        hostCaseId: null,
        loadAlwaysFromURL: false,
        propertyConfig: {
            patient: [],
            summary: [],
            expanded: []
        },
        confirm: {
            display: false,
            title: ''
        },
        activity: [],
        noteTypes: [],
        workItem: {
            assignee: '',
            owner: '',
            aging_days: '',
            codable_days: ''
        },
        onLoad: function (caseRun) { },
        onChargeSessionAction: function (transactionAction) { },
        onReload: function (params) { },
        onSearchClear: function (codeQuery) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        handleAddAllCodes: function (searchSelection) { },
        handleRemoveAllCodes: function (codeChange) { },
        onChargeSessionMetaEdit: function (chargeSession) { },
        onCodeUpdate: function (changeDetail) { },
        onCodeRemove: function (changeDetail) { },
        onTimeBasedCodeAdd: function (time, age) { },
        onTimeBasedCodeUpdate: function (time, age) { },
        onCodeSearchDrop: function (changeDetail) { },
        onTransactionSharedDiagnosisChange: function (changeDetail) { },
        onPrompt: function (action) { },
        onPopUpClose: function () { },
        onFeatureActivation: function (selection) { },
        onNavigate: function (caseId, replace, serviceLine) { },
        hidevitalwareIssuesModal: function () { },
        onImprovementAdd: function (documentImprovement) { },
        onImprovementUpdate: function (documentImprovement) { },
        onImprovementRemove: function (documentImprovement) { },
        onProviderAdd: function (documentImprovement) { },
        onProviderRemove: function (documentImprovement) { },
        onProviderUpdate: function (documentImprovement) { },
        onDocumentImprovementSearch: function (codeQuery) { },
        showAmplifyFeedback: function (feedback) { },
        onProviderSearch: function (query) { },
        updateValue: function (val) { },
        updateCase: function (idAndUpdates) { },
        loadRoles: function (roles) { },
        getFlagItems: function (activeItem) { },
        setActiveMiniTab: function (activeTabName) { },
        setUnresolvedDocuments: function (value) { },
        showCoderNotesInfo: function (coderNotesParams) { },
        searchResults: {},
        codeSearchResultsV2: {},
        displayAddCharge: false,
        showAddChargeError: false,
        showLoadingSubmission: false,
        showLoadingCancelation: false,
        showSizeExpWarning: false,
        showFeedBack: false,
        showSubmittedFeedback: false,
        showCanceledFeedback: false,
        submittedFeedbackTimer: false,
        showvitalwareIssuesModal: false,
        toggleHoldCaseModal: false,
        toggleExclusionCaseModal: false,
        toggleSplitCaseModal: false,
        showCoderNotesModal: false,
        submitOldCaseModal: false,
        vitalwareIssues: [],
        mergeSplitHistoryIssues: [],
        caseAccessTime: '',
        activeMiniTab: ui_common_1.commonEnums.MiniTabLabels.CHARGES_LABEL,
        showUnresolvedDocuments: false
    };
    return CodeBench;
}(react_1["default"].Component));
exports.CodeBench = CodeBench;
//# sourceMappingURL=code-bench.js.map